module.exports = __webpack_public_path__ + "img/alert-square.fc347e2b.svg";